import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";

function useUnit({ amount = 1, format = "symbol", ...props }: Props) {
  const { t } = useTranslation();
  const [key, unit] = props.unit.split(":");

  return t(
    `units.${key}.${unit}.${format}.${amount > 1 ? "plural" : "singular"}`,
  );
}

function Unit(props: Props) {
  const symbol = useUnit(props);

  return <>{symbol}</>;
}

export { Unit, useUnit };
